import superagentRequest from 'superagent'
import { map, get } from 'lodash-es'
import 'regenerator-runtime/runtime'
import { sentryReportError, getAbsoluteUrl, getApiBaseUrl } from '.'

superagentRequest.parse['application/x-javascript'] = JSON.parse

const requestData = (options) => {
  const baseUrl = getApiBaseUrl()
  const requestUrl = get(options, 'url', '/api/echo')
  const url = getAbsoluteUrl(requestUrl, baseUrl)

  return {
    method: 'POST',
    success: () => {},
    error: () => {},
    ...options,
    url, // it comes after options so it can't be overwritten
    data: {
      ...options.data,
      format: 'json',
      raw: '1',
    },
  }
}

const requestPromise = (data) => {
  if (data.method === 'POST') {
    return superagentRequest
      .post(data.url)
      .withCredentials()
      .type('form')
      .send(data.data)
  }

  return superagentRequest.get(data.url).withCredentials().query(data.data)
}

const requestUploadPromise = (data) => {
  const request = superagentRequest
    .post(data.url)
    .withCredentials()
    .field(data.data)

  if (data.onProgress) {
    request.on('progress', data.onProgress)
  }

  map(data.files, (file) => request.attach(...file))

  return request
}

const parseRequest = (text) => {
  const json = JSON.parse(text)

  if (json.status === 'error') {
    const err = new Error(json.message || 'Undefined error')
    err.name = json.code

    throw err
  }

  return json
}

const handleRequest = async (opts, requestFunc) => {
  const data = requestData(opts)
  try {
    const response = await requestFunc(data)
    const json = parseRequest(response.text)

    data.success(json)
    return json
  } catch (e) {
    sentryReportError(e)

    data.error(e)
    throw e
  }
}

const apiRequest = (opts) => handleRequest(opts, requestPromise)
const apiUpload = (opts) => handleRequest(opts, requestUploadPromise)

function apiRequestPromise(opts) {
  const options = {
    url: '/api/echo',
    method: 'POST',
    data: {},
    ...opts,
  }

  const data = { ...options.data, format: 'json', raw: '1' }

  let ret

  if (options.method === 'POST') {
    ret = superagentRequest.post(options.url).type('form').send(data)
  } else {
    ret = superagentRequest.get(options.url).query(data)
  }

  return ret
}

function apiMiddleware({ dispatch }) {
  return (next) => (action) => {
    const {
      types,
      request,
      success: successCallback,
      error: errorCallback,
    } = action

    if (typeof types !== 'object' || typeof request !== 'object') {
      return next(action)
    }

    if (types.length !== 3) {
      throw new Error('Expected "types" to be array of 3')
    }

    const [INIT, SUCCESS, ERROR] = types

    dispatch({ type: INIT, requestData: request.data })

    request.success = (data) => {
      dispatch({
        type: SUCCESS,
        data,
        requestData: request.data,
      })
      if (typeof successCallback !== 'undefined') {
        successCallback(data, dispatch)
      }
    }

    request.error = (error, data) => {
      dispatch({
        type: ERROR,
        error,
        data,
        requestData: request.data,
      })
      if (typeof errorCallback !== 'undefined') {
        errorCallback(error, data, dispatch)
      }
    }

    return apiRequest(request)
  }
}

const API = {
  request: apiRequest,
  apiMiddleware,
}

export {
  API as default,
  apiRequest as request,
  apiUpload as requestUpload,
  apiRequestPromise,
  apiMiddleware,
}
